import { c as _c } from "react/compiler-runtime";
import './help-me-choose-answers.scss';
import { parseAsString, useQueryState } from 'nuqs';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SelectionCardsGroup } from '../../../molecules/selection-cards-group/selection-cards-group.tsx';
import { boyImage } from '../images/boy-help-me-choose.ts';
import { girlImage } from '../images/girl-help-me-choose.ts';
import { createAnswers } from '../utils/answers.ts';
export const HelpMeChooseGender: React.FC = () => {
  const $ = _c(12);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["help-me"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  const [gender, setGender] = useQueryState("gender", parseAsString);
  let t1;
  if ($[1] !== gender) {
    t1 = gender ? [gender] : [];
    $[1] = gender;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const [controlledGender, setControlledGender] = useState(t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    const genderCategories = [{
      label: "boy",
      value: "Male",
      imageUrl: boyImage
    }, {
      label: "girl",
      value: "Female",
      imageUrl: girlImage
    }];
    t2 = createAnswers("gender", genderCategories);
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const genderAnswers = t2;
  let t3;
  if ($[4] !== setGender) {
    t3 = nextValues => {
      const value = nextValues && nextValues.length > 0 ? nextValues[0] : null;
      const isChecked = !!value;
      if (isChecked) {
        setGender(value);
      }
      if (!isChecked) {
        setGender(null);
      }
      setControlledGender(isChecked ? [value] : []);
    };
    $[4] = setGender;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleCheckboxChange = t3;
  let t4;
  if ($[6] !== t) {
    t4 = t("genderAnswers.groupLabel");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== controlledGender || $[9] !== handleCheckboxChange || $[10] !== t4) {
    t5 = <div className="HelpMeChooseAnswers flex flex-col sm:flex-row gap-comfy-sm justify-center align-center"><SelectionCardsGroup cards={genderAnswers} dynamicColumnLength={true} selectionMode="single" value={controlledGender} label={t4} onChange={handleCheckboxChange} /></div>;
    $[8] = controlledGender;
    $[9] = handleCheckboxChange;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};